import header from "./fa/header";
import footer from "./fa/footer";
import home from "./fa/home";
import aboutJavad from "./fa/aboutJavad";
import aboutFaranack from "./fa/aboutFaranack";
import contactPage from "./fa/contactPage";
import notFound from "./fa/notFound";

export default {
  header,
  footer,
  home,
  aboutJavad,
  aboutFaranack,
  contactPage,
  notFound,
};
